import { LinkOpenBankingDocumentRequirementContentDE } from './LinkOpenBankingDocumentRequirementContentDE.js';
import { TrueLayerDocumentRequirementContentUK } from './TrueLayerDocumentRequirementContentUK.js';
import { useLocale } from '../../../../hooks/useLocale.js';

export const LinkOpenBankingDocumentRequirementContent = () => {
  const { isDE } = useLocale();
  if (isDE) {
    return <LinkOpenBankingDocumentRequirementContentDE />;
  }

  return <TrueLayerDocumentRequirementContentUK />;
};
